import $ from 'jquery'
import dataProvider from 'service/data_provider'
import Controller from 'lib/controller'
import HeaderView from 'bundle/home_page/view/header'
import PaywallView from 'component/paywall/paywall'
import Router from 'service/router'
import FullViewportImage from 'component/full_viewport_image/full_viewport_image'

export function getUrl(registrationTrigger) {
    const query = registrationTrigger ? { trigger: registrationTrigger } : null
    return Router.path('registration_power_layer_new', null, { query })
}

// TODO INCONTENT-374: get rid of jQuery selector
export function hasOpenLoginPopover() {
    return $('.js-header-login-popover').is(':visible')
}

const ArticleController = Controller.extend({
    _autoShowPaywallTimeout: null,
    _autoShowRegistrationModalTimeout: null,

    events: {
        'click .js-paywall-trigger': '_onPaywallTriggerClick',
        'click .js-guide-paywall-back': '_onArticlPaywallBack',
    },

    initialize() {
        this.initHeader()

        this._views = {
            paywallModal: null,
            registrationModal: null,
        }

        this._initializeViews()
    },

    _initializeViews() {
        this._initPaywall()
        this._timeTriggeredPaywall()

        this.$('.js-full-viewport-image').each((index, el) => {
            this.initSubview(FullViewportImage, { el })
        })
    },

    initHeader() {
        new HeaderView({
            el: '.js-fading-header',
            join: '.js-fading-header-join',
        })
    },

    _initPaywall() {
        this._views.paywallModal = this.initSubview(PaywallView, {
            el: this.$('.js-show-paywall'),
            paywallType: 'article',
            upgradeHandler: 'article',
            upgradeHandlerParameters: '',
            trackingOptions: {
                name: 'ut:content/layer/time_triggered',
            },
        })

        this._views.paywallModal.on('open', () => window.clearTimeout(this._autoShowPaywallTimeout))
    },

    _onPaywallTriggerClick(e) {
        e.preventDefault()

        const paywallTrigger = this.$(e.currentTarget)

        this._views.paywallModal = this.initSubview(PaywallView, {
            el: paywallTrigger,
            paywallType: 'article',
            upgradeHandler: 'article',
            upgradeHandlerParameters: '',
        })

        this._views.paywallModal.open()
        window.clearTimeout(this._autoShowPaywallTimeout)
    },

    _timeTriggeredPaywall() {
        const showTimeTriggeredPaywall = dataProvider.get('timeTriggeredPaywall')

        if (showTimeTriggeredPaywall) {
            this._autoShowPaywallTimeout = window.setTimeout(() => {
                this._views.paywallModal.open()
            }, 5000)
        }
    },

    _onArticlPaywallBack() {
        const history = window.history

        if (history.length > 1) {
            if (document.referrer.indexOf('/registration') > -1) {
                return
            }
            history.back()
            return false
        }
    },
})

export default new ArticleController()
